import { render } from "./RequirdDetails.vue?vue&type=template&id=c6402b26"
import script from "./RequirdDetails.vue?vue&type=script&lang=js"
export * from "./RequirdDetails.vue?vue&type=script&lang=js"

import "./RequirdDetails.vue?vue&type=style&index=0&id=c6402b26&lang=scss"

import exportComponent from "D:\\Build Apps\\jlm_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__